import moment from 'moment';
import React, { FC } from 'react';
import { DISPLAY_DATE_FORMAT } from '../../constants/dates';

interface IProps {
  date: string;
  format?: string;
}

const dateFormatSetting = localStorage.getItem('dateFormat');
const displayDateFormat = dateFormatSetting
  ? dateFormatSetting
  : DISPLAY_DATE_FORMAT;

const FormattedDate: FC<IProps> = ({ date, format = displayDateFormat }) => {
  return <>{moment(date).format(format)}</>;
};

export { FormattedDate };
